<template>
    <tr class="is-danger">
        <td class="has-text-centered">
            <span>{{ rowNumber }}</span>
        </td>
        <td>
            <editable
                class="test-answer builtin-input"
                :class="{'is-danger': textError}"
                :placeholder="trans.edit_form.question_tabs.question_answers_text_placeholder"
                v-model="answer.text"
                @input="clearErrors"
                v-if="!disabled"
            />
            <p v-else class="test-answer builtin-input">{{answer.text}}</p>
            <p v-if="textError" class="help is-danger">{{ textError }}</p>
        </td>
        <td>
            <input
                v-if="isHasPoints"
                v-model="answer.points"
                type="number"
                class="builtin-input"
                :class="{'is-danger': pointsErrors}"
                @input="clearErrors"
                :disabled="disabled"
                min="0"
            >
            <label v-else class="checkbox">
                <input type="checkbox" v-model="isRight" class="is-has-points-checkbox" :disabled="disabled">
            </label>
            <p v-if="pointsErrors" class="help is-danger">{{ pointsErrors }}</p>
        </td>
        <td>
            <div
                class="test-question-answer-delete-button icon"
                @click="remove"
                v-if="!disabled"
            >
                <svg>
                    <use xlink:href="#icon-cross"></use>
                </svg>
            </div>
        </td>
    </tr>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "QuestionEditAnswerOptionTableRow",
    data() {
        return {
            isRight: false,
        };
    },
    computed: {
        ...mapGetters('tests',[
            'trans',
            'testEditor',
        ]),
        textError() {
            try {
                return this.testEditor.errors[this.questionId][`answers.${this.answerId}.text`][0];
            } catch {}
        },
        pointsErrors() {
            try {
                return this.testEditor.errors[this.questionId][`answers.${this.answerId}.points`][0];
            } catch {}
        }
    },
    props: {
        answer: Object,
        answerId: {
            value: [String, Number]
        },
        questionId: [String, Number],
        rowNumber: Number,
        isHasPoints: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        ...mapActions('tests', [
            'deleteAnswer',
            'clearTestQuestionError',
        ]),
        remove() {
            if (this.disabled) {
                return;
            }

            this.deleteAnswer({
                questionId: this.questionId,
                answerIndex: this.answerId
            });
        },
        clearErrors() {
            this.clearTestQuestionError(this.questionId);
        }
    },

    watch: {
        isRight: function (value) {
            this.answer.points = + value;
        },
    },

    created() {
        this.isRight = this.answer.points;
    }
}
</script>

<style lang="scss" scoped>
@import 'resources/sass/variables';

.bulma {
    .builtin-input {
        border: none;
        box-shadow: none;
        padding: 0;
        cursor: text;
        min-height: 20px;
        font-weight: normal;
        font-size: inherit;
        outline: none;
        color: $black;
        max-width: 100%;

        &.is-danger {
            border: solid 1px $danger;
        }
    }

    .test-answer {
        resize: none;

        &:focus:empty {
            min-height: 20px;
        }

        &:before {
            margin: 0 !important;
        }
    }

    .icon {
        color: $grey;
        fill: $grey;
        padding: 0;
        width: 100%;
        height: 100%;

        svg {
            width: 20px;
            height: 20px;
        }

        &.test-question-answer-delete-button:hover {
            color: $tests-red;
            fill: $tests-red;
            cursor: pointer;
        }
    }

    .is-has-points-checkbox {
        width: 1rem;
        height: 1rem;
    }
}
</style>